export default {
  roles: {
    produtor: 'produtor',
    frigorifico: 'frigorifico',
    admin: 'admin',
  },
};
